module.exports = __webpack_public_path__ + "static/media/planet.f90a352a.png";